import { validDimensionSlug } from '@features/reports';
import { Stack, Typography } from '@mui/material';
import { DimensionEditor, DimensionEditorProps } from './DimensionEditor';
import { SubdimensionsDialogProps } from './SubdimensionsDialog';
import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';

export type NameValuePair = {
  name: string;
  value: string;
};

type DimensionSelectorProps = {
  availableDimensions: string[];
  subdimensions: NameValuePair[];
  setSubdimensionDictionary: SubdimensionsDialogProps['setSubdimensionDictionary'];
  subdimensionDictionary: SubdimensionsDialogProps['subdimensionDictionary'];
  getFieldPath: (dimensionName: string) => DimensionEditorProps['fieldPath'];
};

export const DimensionSelector = (props: DimensionSelectorProps) => (
  <>
    <Typography component="h6" variant="h6">
      Dimensions
    </Typography>
    Only the selected dimensions will be included in the report output.
    <Stack spacing={0} sx={{ marginTop: 0 }}>
      {props.availableDimensions.map(dimensionName => {
        const fieldPath = props.getFieldPath(dimensionName);

        return (
          <DimensionEditor
            fieldPath={fieldPath}
            key={dimensionName}
            dimensionName={
              validDimensionSlug(dimensionName)
                ? apiSlugToDimensionName[dimensionName]
                : dimensionName
            }
            subdimensions={
              props.subdimensions
                ? props.subdimensions.filter(
                    stat => stat.name === dimensionName
                  )
                : []
            }
            subdimensionDictionary={props.subdimensionDictionary}
            setSubdimensionDictionary={props.setSubdimensionDictionary}
          />
        );
      })}
    </Stack>
  </>
);
